<template>
  <div class="cart-summary-wrapper" v-if="cartCount!==0">
    <ul class="summary-ul">
      <li class="summary-li head">
        Price Details
      </li>
      <li class="summary-li">
        <span>
          Price ({{cartCount}})
        </span>
        <span>
          {{cartItemsTotal | currencyConversion}}
        </span>
      </li>
      <li class="summary-li"
          v-if="getBuyNowProduct.length > 0 && isShowCharge"
      >
        <span>
          Shipping Charges
        </span>
        <span class="delv">
          {{this.getShippingCharge * this.getBuyNowProductCount | currencyConversion}}
        </span>
      </li>
      <li class="summary-li" v-else-if="isShowCharge">
        <span>
          Shipping Charges
        </span>
        <span class="delv">
          {{this.getShippingCharge * this.getCartTotalQuantity | currencyConversion}}
        </span>
      </li>
      <li class="summary-li"
          v-if="getBuyNowProduct.length > 0 && isShowCharge"
      >
        <span>
          Tax Charges
        </span>
        <span class="delv">
          {{this.getTaxCharge * this.getBuyNowProductCount | currencyConversion}}
        </span>
      </li>
      <li class="summary-li" v-else-if="isShowCharge">
        <span>
          Tax Charges
        </span>
        <span class="delv">
          {{this.getTaxCharge * this.getCartTotalQuantity | currencyConversion}}
        </span>
      </li>

      <li class="summary-li pay">
        <span>
          Amount
        </span>
        <span>
          {{cartTotal | currencyConversion}}
        </span>
      </li>
      <li class="summary-li offer"
          v-if="getPromoCode && getPromoCode.discount_price"
          style="color: #388e3c"
      >
        Coupon applied.You will save {{getPromoCode.discount_price|currencyConversion}} on this order
      </li>
      <li class="summary-li offer"
          v-if="getGiftCardAmount.subtotal"
          style="color: #388e3c"
      >
        Gift Card applied {{getGiftCardAmount.subtotal|currencyConversion}} on this order
      </li>
      <li
        class="summary-li offer"
        v-if="cartTotalOffer !== 0"
				style="color: #388e3c"
      >
        You will save {{cartTotalOffer|currencyConversion}} on this order
      </li>

      <!--Exclude feature: Redeem Coin Rules-->

      <!--<li class="summary-li offer" v-if="getCoinDetails.coinValue">-->
      <!--{{getCoinDetails.coinNo}} coins redeem on this order, You will save {{getCoinDetails.coinValue|currencyConversion}}-->
      <!--</li>-->

      <!--<li class="mt-4">-->
        <!--<p id="redeem-coin"-->
           <!--class="redeem-coin">-->
          <!--Redeem Coins-->
          <!--<span>-->
        <!--<span class="question">?</span>-->
        <!--<span class="field-tip">-->
          <!--<span class="tip-content m-2">-->
            <!--<span v-for="(rule,index) in getLoyaltyRules"-->
                  <!--:key="index">-->
                 <!--{{index}}: {{rule}}-->
              <!--<br>-->
            <!--</span>-->
          <!--</span>-->
        <!--</span>-->
      <!--</span>-->
        <!--</p>-->
      <!--</li>-->

      <!--Exclude feature: Redeem Coin Rules-->

      <!--<li class="summary-li offer" v-if="getUserData.coins!=0">-->
        <!--Redeem your {{getUserData.coins}} coins to save {{(getLoyaltyRules.value_of_one_coin * getUserData.coins)|currencyConversion}} on this order-->
      <!--</li>-->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		cartTotal: {
			default: 0,
			type: Number
		},
		cartTotalOffer: {
			default: 0,
			type: Number
		},
		cartItemsTotal: {
			default: 0,
			type: Number
		},
		cartCount: {
			default: 0,
			type: Number
		}
	},
	computed: {
		...mapGetters('user', [
			'getGiftCardAmount',
			'getUserData',
			'getCoinDetails',
			'getPromoCode'
		]),
		...mapGetters('siteData', [
			'getLoyaltyRules'
		]),
		...mapGetters('charges', ['getShippingCharge', 'getTaxCharge', 'isShowCharge']),
		...mapGetters('cart', ['getCartTotalQuantity']),
		...mapGetters('buynow', ['getBuyNowProduct', 'getBuyNowProductCount'])
	}
}
</script>

<style scoped>
  .redeem-coin {
    padding: 0.75rem;
    padding-bottom: 0.5rem;
    display: flex;
    color: #0b690e
  }
  .question {
    border-radius: 50%;
    background-color: #fff;
    color: #0b690e;
    font-weight: 500;
    width: 16px;
    height: 16px;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    display: inline-block;
    border: 1px solid #e0e0e0;
    box-shadow: 0 0 1px 0 rgba(0,0,0,.2);
    vertical-align: middle;
    margin: 0 2px 0 8px;
    cursor: pointer;
  }
  .field-tip {
    display:none;
    position:absolute;
  }
  span:hover .field-tip {
    display:block;
  }
  .tip-content {
    overflow-y: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width:100%;
    height:100px;
    /*overflow:visible;*/
    background: white;
    display:block;
  }
</style>
